import { endOfWeek, startOfWeek } from 'date-fns';
import { th } from 'date-fns/locale';
import { DateRangePresetId } from 'src/app/components/date-picker/date-range-picker';
import { NotImplementedError } from 'src/app/utils/error';

export class CustomRangeHelper {
    public static calculateDateRange(
        preset: DateRangePresetId,
        today?: Date
    ): [start: Date, end: Date] {
        if (today === undefined) {
            today = this.todayUTC();
        }

        switch (preset) {
            case 'today':
                return [today, today];
            case 'yesterday':
                const yesterday = this.addDaysUTC(today, -1);
                return [yesterday, yesterday];
            case 'last 7 days':
                const start7 = this.addDaysUTC(today, -7);
                return [start7, today];
            case 'last 14 days':
                const start14 = this.addDaysUTC(today, -14);
                return [start14, today];
            case 'last 30 days':
                let start30 = this.addDaysUTC(today, -30);
                return [start30, today];
            case 'last 60 days':
                const start60 = this.addDaysUTC(today, -60);
                return [start60, today];
            case 'last 90 days':
                const start90 = this.addDaysUTC(today, -90);
                return [start90, today];
            case 'last 180 days':
                const start180 = this.addDaysUTC(today, -180);
                return [start180, today];
            case 'last 365 days':
                const start365 = this.addDaysUTC(today, -365);
                return [start365, today];
            case 'last 540 days':
                const start540 = this.addDaysUTC(today, -540);
                return [start540, today];
            case 'last 720 days':
                const start720 = this.addDaysUTC(today, -720);
                return [start720, today];

            case 'custom': {
                throw new NotImplementedError();
            }
            default:
                // exhaustiveness check;
                // rangeName has type never, if every possible value is handled in the switch cases.
                // Otherwise, the following line will result in compiler error:
                // "Type 'string' is not assignable to type '[start: D, end: D]'"
                throw new Error(
                    'Not all cases are handled in switch statement'
                );
        }
    }

    public static calculateMonth(forDay: Date): [start: Date, end: Date] {
        const year = forDay.getUTCFullYear();
        const month = forDay.getUTCMonth();
        const start = new Date(Date.UTC(year, month, 1));
        // https://stackoverflow.com/a/222439
        const end = new Date(Date.UTC(year, month + 1, 0));
        return [start, end];
    }

    // week starts on monday
    public static calculateWeek(forDay: Date): [start: Date, end: Date] {
        // reference implementation start a week on Sunday
        // we want to start week on Monday
        // const weekStartOffset = 1;
        const localStart = startOfWeek(forDay, { weekStartsOn: 1 });
        const start = this.fromLocalToUTC(localStart);

        const localEnd = endOfWeek(forDay, { weekStartsOn: 1 });
        const end = this.fromLocalToUTC(localEnd);
        return [start, end];
    }

    public static todayUTC(): Date {
        const localToday = new Date();
        const today = this.fromLocalToUTC(localToday);
        if (today === null) {
            throw new Error('date creation failed');
        }
        return today;
    }

    public static fromLocalToUTC(date: Date): Date {
        return new Date(
            Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        );
    }

    private static addDaysUTC(date: Date, days: number): Date {
        const result = new Date(date);
        result.setUTCDate(result.getUTCDate() + days);
        return new Date(
            Date.UTC(
                result.getUTCFullYear(),
                result.getUTCMonth(),
                result.getUTCDate()
            )
        );
    }
}
